import React, { useState, useContext, useEffect, useRef } from "react";
import "../quotation/JobInHand.scss";
import { ProductList } from "../../components/quotation/ProductList";
import { ProductQuotation } from "../../components/quotation/ProductQuotation";
import { SubCategory } from "../../components/quotation/SubCategory";
import { MainCategory } from "../../components/quotation/MainCategory";
import { Configuration } from "../../components/quotation/Configurations";
import { SDRequest } from "../../components/quotation/SDRequest";
import { ProductSubCategory } from "../../components/quotation/ProductSubCategory";
import { AssemblyConfigure } from "../../components/quotation/AssemblyConfigure";
import Select, { components } from "react-select";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import PrintModalStart from "../../components/quotation/PrintModalStart";
import DeleteModal from "../../components/common/DeleteModal";
import "react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ProductTabContext } from "../../utils/ProductTabContext";
import useForm from "./useForm";
import FetchData from "../../providers/dataProvider";
import { default as ReactSelect } from "react-select";
import urls from "../../constants";
import AddNewCustomerModal from "../../components/common/AddNewCustomerModal";
import AddNewProjectModal from "../../components/common/AddNewProjectModal";
import ErrorMessage from "../../components/common/ErrorMessage";
import validation from "./validation";
import AddJobInHand from "../../components/quotation/AddJobInHand";
import { CheckNull, getStorageData } from "../../utils/Validate";
import { QuotationPrint } from "../../components/quotation/QuotationPrint";
import { useRolePermission } from "../../hooks/useRolePermission";
import EnquiryNoOptionsMessage from "../../components/enquiry/EnquiryNoOptionsMessage ";
import QuoteFormPanel from "../../components/quotation/QuoteFormPanel";
import { CompleteQuotationRevision } from "../../providers/dataProvider";

const REVISION_STATUSES = new Set([
  "submitted",
  "loi received",
  "submitted for approval",
  "lost",
]);

const getQuotationStatus = (quotationStatusList, ...items) => {
  const statusText = items
    .map((item) => item?.quoteStatus || item?.quoteStatusName || item?.statusDesc || item?.status)
    .find((status) => typeof status === "string" && status.trim());
  if (statusText) return statusText.trim().toLowerCase();

  const quoteStatusId = items
    .map((item) => item?.quoteStatusId)
    .find((statusId) => statusId !== undefined && statusId !== null);
  const status = quotationStatusList?.find(
    (item) => String(item?.id) === String(quoteStatusId)
  )?.statusDesc;

  return typeof status === "string" ? status.trim().toLowerCase() : "";
};

const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000000",
    whiteSpace: "nowrap",
  }),
};

const JobInHand = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationId = location.state?.id;
  const { ProductTab, setProductTab } = useContext(ProductTabContext);
  const { menuRights } = useRolePermission("Quotation")
  const { data: quotationStatusList } = FetchData("quotationStatus");
  const [tabValue, setTabValue] = useState(
    location.state?.initialTab || "General"
  );
  const [paymentTermsData, setPaymentTermsData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [transportModeData, setTransportModeData] = useState([]);
  const [transportModeDataList, setTransportModeDataList] = useState([]);
  const [deliveryTermsData, setDeliveryTermsData] = useState([]);
  const [country, setCountry] = useState("");

  const [paymentTerms, setPaymentTerms] = useState(null);
  const [transportMode, setTransportMode] = useState("");

  const [productListSubmit, setProductListSubmit] = useState(false);
  const [destinationCountry, setDestinationCountry] = useState("");

  //Product Quotation State
  const [productSubmit, setProductSubmit] = useState({
    markRedirect: false,
    markSubmit: false,
  });
  const [attributes, setAttributes] = useState([]);
  const [configSetting, setConfigSetting] = useState([]);
  const [productConfig, setProductConfig] = useState({});
  const [enquirySelection, setEnquirySelection] = useState(null);
  const [revisionCompleting, setRevisionCompleting] = useState(false);
  const revisionCompletionRef = useRef(false);


  const { data: paymentTermsList } = FetchData("paymentterms");
  const { data: countryList } = FetchData("country");
  const { data: transportModeList } = FetchData("deliverymodes");
  const { data: deliveryTermsList } = FetchData("deliveryterms");
  const {
    values,
    setValues,
    projectData,
    customerData,
    HandleFormChange,
    handleSubmit,
    customerList,
    advPaymentLabel,
    createMsg,
    setCreateMsg,
    showNewCust,
    setShowNewCust,
    setShowNewProj,
    setShow,
    SuccessDoneClick,
    ErrorDoneClick,
    errorShow,
    setErrorShow,
    quoteValidityValues,
    quoteValidity,
    setQuoteValidity,
    deliveryLeadTimeValues,
    deliveryLeadTime,
    setDeliveryLeadTime,
    errors,
    setErrors,
    deliveryTerms,
    setDeliveryTerms,
    loading,
    enquiry,
    setEnquiry,
    inquiryList,
    flag,
    setFlag,
    setIsSubmitting,
    show,
    customer,
    setCustomer,
    project,
    setProject,
    disableEnq,
    setDisableEnq,
    distributorList,
    assignedEngineerList,
    setNewAddedCustomer,
    setCustList,
    distributor,
    setDistributor,
    salesEngineer,
    setSalesEngineer,
    currency,
    setCurrency,
    currencyList,
    showNewProj,
    projectList,
    setProjectData,
    quoteGeneral,
    setCustomerData,
    setNewAddedProject,
    setEnquiryData,
    enquiryData,
    projectsList,
    customersList,
    setProjectList,
    setCustomerList,
    editQuotation,
    setQuotUserEntry,
    quotUserEntry,
    currencyDetail,
    setCurrencyDetail,
    qarCurrencyDetail,
    setConversionDisabled,
    conversionDisabled,
    copyStatus
  } = useForm(locationId);

  const selectCustRef = useRef();
  const selectProjRef = useRef();
  const isProductMarkWorkspace = tabValue === "Details" && ProductTab?.tab === "ProductQuotation";
  const isRevisionQuotation = Boolean(values?.id) &&
    REVISION_STATUSES.has(
      getQuotationStatus(
        quotationStatusList,
        values,
        editQuotation?.row,
        location.state?.row
      )
    );

  const selectedDistributorForBase = distributorList?.find(
    (item) => item?.id === values?.distributorId
  );
  const companyBaseCurrency = currencyList?.find(
    (item) => item?.id === selectedDistributorForBase?.currencyId
  );

  useEffect(() => {
    if (!companyBaseCurrency?.shortCode) return;
    if (values?.currencyId !== companyBaseCurrency.id) return;

    setConversionDisabled(true);
    if (Number(values?.conversionRate) !== 1) {
      setValues((prev) => ({ ...prev, conversionRate: 1 }));
    }
  }, [companyBaseCurrency?.id, values?.currencyId, values?.conversionRate]);

  useEffect(() => {
    if (!editQuotation?.id) return;
    if (!companyBaseCurrency?.shortCode) return;

    const row = editQuotation?.row;
    setQuotUserEntry((prev) => ({
      ...prev,
      specialCharges: row?.specialCharges,
      freightCharges: row?.freightCharges,
      customDuty: row?.customDuty,
      clearanceCharges: row?.clearanceCharges,
      tax: row?.tax,
    }));
  }, [editQuotation, projectList, customerList, inquiryList, currencyList, companyBaseCurrency?.shortCode]);

  useEffect(() => {
    if (ProductTab?.tab !== "") {
      setProductTab(ProductTab);
    } else
      setProductTab({ tab: "ProductList", id: 0 });
  }, []);

  useEffect(() => {
    if (location.state?.initialTab === "Details" && values?.id) {
      setTabValue("Details");
      setProductTab({ tab: "ProductList", id: 0 });
    }
  }, [values?.id]);

  useEffect(() => {
    const obj = paymentTermsList?.find(
      (item) => item?.id == paymentTerms?.value
    );
    setValues({
      ...values,
      creditDays: obj?.creditDays,
    });
  }, [paymentTerms]);

  useEffect(() => {
    setDeliveryTermsData([
      ...deliveryTermsList,
      { deliveryDescription: "Others", id: "0" },
    ]);
  }, [deliveryTermsList]);

  useEffect(() => {
    if (distributorList?.find(item => item?.id === values?.distributorId)?.defaultCompanyDistributor === true) {
      setDeliveryTermsData([
        ...deliveryTermsList,
        { deliveryDescription: "Others", id: "0" },
      ]);
      setPaymentTermsData(paymentTermsList)
    }
    else {
      const deliveryTerm = distributorList?.find(item => item?.id === values?.distributorId)?.distributorDeliveryTerms
      const filterDeliverTerm = deliveryTermsList.filter(item1 => deliveryTerm?.some(item2 => item1.id === item2.deliveryTermId));

      const paymentTerm = distributorList?.find(item => item?.id === values?.distributorId)?.distributorPaymentTerms
      const filterPaymentTerm = paymentTermsList.filter(item1 => paymentTerm?.some(item2 => item1.id === item2.paymentTermId));
      setDeliveryTermsData([
        ...filterDeliverTerm,
        { deliveryDescription: "Others", id: "0" },
      ]);
      setPaymentTermsData(filterPaymentTerm)
    }
  }, [values?.distributorId, deliveryTermsList, paymentTermsList, distributorList])

  useEffect(() => {
    setTransportModeDataList(transportModeList);
  }, [transportModeList]);

  useEffect(() => {
    const tes = [...transportModeDataList];
    const obj = deliveryTermsData?.find(
      (item) => item?.id == deliveryTerms?.value
    );
    const ss = obj?.modeofTransports?.split(",").map((ob) => {
      return parseInt(ob);
    });
    if (deliveryTerms?.label != "Others") {
      const tm = transportModeDataList?.filter((ob) => ss?.includes(ob?.id));
      if (tm) setTransportModeData(tm);
    } else setTransportModeData(tes);
  }, [deliveryTerms, transportModeDataList, deliveryTermsData]);

  const HandleShowNewCustomer = () => {
    setShowNewCust(true);
  };

  const HandleShowNewProject = () => {
    setShowNewProj(true);
  };

  const NoOptionsMessage = (props) => {
    if (props?.selectProps?.name == "customer") {
      return (
        <EnquiryNoOptionsMessage
          HandleShowNew={HandleShowNewCustomer}
          selectRef={selectCustRef}
          Master="Customer Master"
          Name="customer name"
          {...props}
        />
      );
    } else if (props?.selectProps?.name == "project") {
      return (
        <EnquiryNoOptionsMessage
          HandleShowNew={HandleShowNewProject}
          selectRef={selectProjRef}
          Master="Project Master"
          Name="project name"
          {...props}
        />
      );
    }
  };

  const handleContinue = () => {
    handleSubmit();
  };

  const refreshValidationErrors = (nextValues, nextSalesEngineer = salesEngineer, nextDeliveryTerms = deliveryTerms) => {
    if (Object.keys(errors).length > 0) {
      setErrors(validation(nextValues, nextSalesEngineer, nextDeliveryTerms));
    }
  };

  const HandleSelect = (selectedOption, params) => {
    if (params === "enquiry") {
      setEnquiry(selectedOption);
      const enqObj = inquiryList?.find((ob) => ob?.id == selectedOption?.value);
      const customerObj = customersList?.find(
        (ob) => ob?.id == enqObj?.customerId
      );
      const projectObj = projectsList?.find(
        (ob) => ob?.id == enqObj?.projectId
      );
      if (customerObj) setDisableEnq(true);
      else setDisableEnq(false);

      const isQAR = enqObj?.currencyId === companyBaseCurrency?.id;

      const updatedValues = {
        ...values,
        customerId: enqObj ? enqObj?.customerId : "",
        enquiryId: selectedOption?.value,
        projectId: enqObj ? enqObj?.projectId : "",
        customerAddress: enqObj ? enqObj?.customerAddress : "",
        phone: enqObj ? enqObj?.mobileNo : "",
        emailAddress: enqObj ? enqObj?.emailAddress : "",
        contactPerson: enqObj ? enqObj?.contactPerson : "",
        salesEngineerId: enqObj ? enqObj?.salesEngineerId : "",
        currencyId: enqObj?.currencyId ? enqObj?.currencyId : values?.currencyId,
      };

      setValues(updatedValues);
      if (enqObj?.currencyId) setConversionDisabled(isQAR);

      if (customerObj)
        setCustomer({
          label: customerObj?.customerName,
          value: customerObj?.customerId,
        });
      else setCustomer(null);

      refreshValidationErrors(updatedValues);
    }
    if (params === "currency") {
      setCurrency(selectedOption);
      const isQAR = selectedOption?.value === companyBaseCurrency?.id;
      const selectedCurrencyObj = currencyList?.find(item => item?.id === selectedOption?.value);
      const selectedCurrencyRate = Number(
        selectedCurrencyObj?.conversionRate ??
        selectedCurrencyObj?.exchangeRate ??
        selectedOption?.conversionRate ??
        selectedOption?.exchangeRate ??
        0
      );
      const nextValues = {
        ...values,
        currencyId: selectedOption?.value,
        conversionRate: isQAR
          ? 1
          : selectedCurrencyRate > 0
            ? Number(selectedCurrencyRate.toFixed(2))
            : "",
      };
      setValues(nextValues);
      setConversionDisabled(isQAR);
      setCurrencyDetail(selectedCurrencyObj);
      refreshValidationErrors(nextValues);
    }
    if (params === "customer") {
      const customerObj = customersList?.find(
        (ob) => ob?.id == selectedOption?.value
      );
      setCustomer(selectedOption);
      const nextValues = {
        ...values,
        customerId: selectedOption?.value || "",
        enquiryId: "",
        customerAddress: customerObj?.address || "",
        phone: customerObj?.phone || "",
        emailAddress: customerObj?.email || "",
        salesEngineerId: customerObj?.assignedEngineerId || "",
        contactPerson: customerObj?.customerContact?.[0]?.name || ""
      };
      setValues(nextValues);
      refreshValidationErrors(nextValues);
    }
    if (params === "project") {
      setProject(selectedOption);
      const nextValues = {
        ...values,
        projectId: selectedOption?.value,
        enquiryId: "",
      };
      setValues(nextValues);
      refreshValidationErrors(nextValues);
    }
    if (params === "paymentterms") {
      setPaymentTerms(selectedOption);
      const nextValues = {
        ...values,
        paymentTermId: selectedOption?.value,
      };
      setValues(nextValues);
      refreshValidationErrors(nextValues);
    }
    if (params === "deliveryterms") {
      setDeliveryTerms(selectedOption);
      const nextValues = {
        ...values,
        deliveryTermId:
          selectedOption?.value == "Others" ? 0 : selectedOption?.value,
        destination: "",
        destinationCountryId: 0,
        modeOfTransportId: "",
      };
      setValues(nextValues);
      setDestinationCountry("");
      setTransportMode("");
      refreshValidationErrors(nextValues, salesEngineer, selectedOption);
    }
    if (params === "quoteValidity") {
      setQuoteValidity(selectedOption);
      const nextValues = {
        ...values,
        quoteValidity: selectedOption?.value,
      };
      setValues(nextValues);
      refreshValidationErrors(nextValues);
    }
    if (params === "transportmode") {
      setTransportMode(selectedOption);
      const nextValues = {
        ...values,
        modeOfTransportId: selectedOption?.value,
      };
      setValues(nextValues);
      refreshValidationErrors(nextValues);
    }
    if (params === "destinationCountry") {
      setDestinationCountry(selectedOption);
      const nextValues = {
        ...values,
        destinationCountryId: selectedOption?.value,
      };
      setValues(nextValues);
      refreshValidationErrors(nextValues);
    }
    if (params === "deliveryLeadTime") {
      const nextValues = {
        ...values,
        deliveryLeadTimeId:
          selectedOption?.value == "Others" ? 0 : selectedOption?.value,
      };
      setValues(nextValues);
      refreshValidationErrors(nextValues);
    }
    if (params === "distributor") {
      //const isQAR = currencyList?.some(item => item?.id === selectedOption?.currencyId && item?.shortCode === "QAR");
      const isQAR = true;
      const nextValues = {
        ...values,
        distributorId: selectedOption?.value,
        projectId: "",
        customerId: "",
        enquiryId: "",
        customerAddress: "",
        phone: "",
        emailAddress: "",
        salesEngineerId: "",
        countryId: selectedOption?.countryId,
        currencyId: selectedOption?.currencyId,
        conversionRate: isQAR ? 1 : selectedOption?.conversionRate > 0 ? Number(selectedOption.conversionRate).toFixed(2) : "",
        contactPerson: ""
      };
      setValues(nextValues);
      setConversionDisabled(isQAR);
      refreshValidationErrors(nextValues);
    }
    if (params === "salesEngineer") {
      setSalesEngineer(selectedOption);
      const nextValues = {
        ...values,
        salesEngineerId: selectedOption?.value,
      };
      setValues(nextValues);
      refreshValidationErrors(nextValues, selectedOption, deliveryTerms);
    }
  };

  useEffect(() => {

    setEnquiryData([
      ...inquiryList?.filter(
        (item) =>
          item?.projectId === values?.projectId &&
          item?.conversionStatus === "Pending"
      ),
      ...(values?.enquiryId
        ? inquiryList?.filter(
          (item) =>
            item?.id === values?.enquiryId &&
            item?.conversionStatus !== "Pending"
        )
        : []),
    ]);

    setProjectData(projectsList?.filter((item) => item?.distributorId === values?.distributorId))
    setCustomerData(customersList?.filter((item) => item?.distributorId === values?.distributorId))
  }, [values?.distributorId, values?.enquiryId, values?.projectId, inquiryList, projectsList, customersList])

  useEffect(() => {
    const enqObj = inquiryList?.find((ob) => ob?.id == values?.enquiryId);
    setEnquirySelection(enqObj)
  }, [values?.enquiryId])

  const handleRedirect = () => {
    setValues({});
    navigate("/quotation");
  };

  const handleProductDetails = () => {
    const formErrors = validation(values, deliveryTerms, advPaymentLabel);
    if (Object.keys(formErrors).length === 0) {
      setTabValue("Details");
      setProductTab({ tab: "ProductList", id: 0 });
      navigate(location.pathname, {
        replace: true,
        state: { ...location.state, initialTab: "Details" },
      });
    } else {
      setErrors(formErrors);
      setIsSubmitting(false);
    }
  };

  const handleWorkspaceSectionChange = (sectionKey) => {
    if (sectionKey === "Details") {
      handleProductDetails();
      return;
    }

    setTabValue("General");
    setProductTab({ tab: "ProductList", id: 0 });
    navigate(location.pathname, {
      replace: true,
      state: { ...location.state, initialTab: "General" },
    });
  };


  //   const handleWorkspaceSectionChange = (sectionKey) => {
  //     if (sectionKey === "Details") {
  //       setTabValue("Details");
  //       setProductTab({ tab: "ProductList", id: 0 });
  //       return;
  //     }
  //     setTabValue("General");
  //     setProductTab({ tab: "ProductList", id: 0 });
  // };

  const CloseOthersOption = (params) => {
    if (params == "deliveryLeadTime") {
      setDeliveryLeadTime(null);
      setValues({
        ...values,
        deliveryLeadTime: "",
        deliveryLeadTimeId: 0,
      });
    } else {
      setDeliveryTerms(null);
      setValues({
        ...values,
        deliveryTerms: "",
        deliveryTermId: 0,
      });
    }
  };

  /*Product Quotation module Submit*/
  const SaveProductMark = (event) => {
    event.preventDefault();
    setProductSubmit({ markRedirect: false, markSubmit: true });
  };

  const SaveProductMarkAdd = (event) => {
    event?.preventDefault();
    setProductSubmit({ markRedirect: true, markSubmit: true });
  };

  /*Product List module Submit*/
  const SaveProductList = (event) => {
    if (event) event.preventDefault();
    setProductListSubmit(true);
  };

  const saveRevisionDraft = (saveAction) => {
    setValues((previous) => ({ ...previous, isRevisionDraft: true }));
    saveAction?.();
  };

  const completeQuotationRevision = async () => {
    if (revisionCompletionRef.current) return;
    if (!values?.id || !values?.revisionDraftId) {
      setErrorShow({
        show: true,
        errorMessage: {
          errors: [{ message: "The quotation revision draft could not be found. Refresh the quotation and try again." }],
        },
      });
      return;
    }

    revisionCompletionRef.current = true;
    setRevisionCompleting(true);
    try {
      const response = await CompleteQuotationRevision(
        values.id,
        values.revisionDraftId
      );
      const responseData = response?.data || response;
      setValues((previous) => ({
        ...previous,
        ...(responseData && typeof responseData === "object"
          ? {
            revisionNumber: responseData.revisionNumber ?? previous.revisionNumber,
            revisionDraftId: responseData.revisionDraftId ?? previous.revisionDraftId,
            revisionCompletedAtUtc:
              responseData.revisionCompletedAtUtc ?? previous.revisionCompletedAtUtc,
          }
          : {}),
        isRevisionDraft: false,
      }));
      setCreateMsg({
        message: "Quotation revision completed successfully",
        successData: responseData,
        status: 200,
      });
      setShow(true);
    } catch (error) {
      setErrorShow({
        show: true,
        errorMessage: { errors: [{ message: error?.message || "Failed to complete quotation revision." }] },
      });
    } finally {
      revisionCompletionRef.current = false;
      setRevisionCompleting(false);
    }
  };

  const navigateToQuotationGeneral = () => {
    if (quoteGeneral?.id)
      navigate("/quotation-general", {
        state: {
          row: quoteGeneral?.row,
          id: quoteGeneral?.id,
        },
      });
    else
      navigate("/quotation");
  };

  useEffect(() => {
    const backTarget = quoteGeneral?.id
      ? {
        pathname: "/quotation-general",
        state: {
          row: quoteGeneral?.row,
          id: quoteGeneral?.id,
        },
      }
      : { pathname: "/quotation" };

    window.dispatchEvent(new CustomEvent("pathfinderHeaderMetaChange", {
      detail: {
        pathname: "/job-in-hand",
        title: values?.id
          ? (values?.quoteType === 2 ? "Tender" : "Job In Hand") + " : " + values?.quoteReference
          : "New Quotation",
        backTarget,
      },
    }));

    return () => {
      window.dispatchEvent(new CustomEvent("pathfinderHeaderMetaChange", {
        detail: {
          pathname: "/job-in-hand",
          clear: true,
        },
      }));
    };
  }, [quoteGeneral?.id, quoteGeneral?.row, values?.id, values?.quoteReference]);
  return (
    <>
      <div className="container-fluid" id="jobInHandSec">
        <section className="general-tab-sec">
          <div className="row m-0">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
              <QuoteFormPanel
                hideHeader={isProductMarkWorkspace}
                tabs={[
                  {
                    key: "General",
                    label: "General Information",
                    icon: "fas fa-file-alt",
                  },
                  {
                    key: "Details",
                    label: "Manage Products",
                    icon: "fas fa-boxes",
                    count: values?.products?.length || 0,
                  },
                ]}
                activeTab={tabValue}
                onTabChange={handleWorkspaceSectionChange}
                rightActions={
                  !isProductMarkWorkspace && values?.products?.length > 0 && menuRights?.canPrint === true ? (
                    <QuotationPrint
                      distributorList={distributorList}
                      values={values}
                      currencyDetail={currencyList?.find(item => item?.id === values?.currencyId)}
                      disabled={values?.isRevisionDraft === true}
                    />
                  ) : null
                }
              >
                {tabValue == "General" && (
                  <AddJobInHand
                    values={values}
                    inquiryList={inquiryList}
                    HandleSelect={HandleSelect}
                    enquiry={enquiry}
                    setEnquiry={setEnquiry}
                    customerData={customerData}
                    customer={customer}
                    NoOptionsMessage={NoOptionsMessage}
                    errors={errors}
                    HandleFormChange={HandleFormChange}
                    countryList={countryList}
                    country={country}
                    setCountry={setCountry}
                    currency={currency}
                    distributor={distributor}
                    distributorList={distributorList}
                    setDistributor={setDistributor}
                    salesEngineer={salesEngineer}
                    assignedEngineerList={assignedEngineerList}
                    setSalesEngineer={setSalesEngineer}
                    projectData={projectData}
                    project={project}
                    quoteValidityValues={quoteValidityValues}
                    quoteValidity={quoteValidity}
                    setQuoteValidity={setQuoteValidity}
                    paymentTermsList={paymentTermsData}
                    paymentTerms={paymentTerms}
                    setPaymentTerms={setPaymentTerms}
                    deliveryLeadTimeValues={deliveryLeadTimeValues}
                    deliveryLeadTime={deliveryLeadTime}
                    setDeliveryLeadTime={setDeliveryLeadTime}
                    deliveryTermsList={deliveryTermsData}
                    deliveryTerms={deliveryTerms}
                    setDeliveryTerms={setDeliveryTerms}
                    transportModeList={transportModeData}
                    transportMode={transportMode}
                    setTransportMode={setTransportMode}
                    destinationCountry={destinationCountry}
                    setDestinationCountry={setDestinationCountry}
                    handleContinue={handleContinue}
                    isRevisionQuotation={isRevisionQuotation}
                    onSaveRevisionDraft={() =>
                      saveRevisionDraft(() => handleContinue())
                    }
                    onCompleteRevision={completeQuotationRevision}
                    revisionCompleting={revisionCompleting}
                    handleRedirect={handleRedirect}
                    selectCustRef={selectCustRef}
                    selectProjRef={selectProjRef}
                    advPaymentLabel={advPaymentLabel}
                    CloseOthersOption={CloseOthersOption}
                    loading={loading}
                    currencyList={currencyList}
                    setCurrency={setCurrency}
                    enquirySelection={enquirySelection}
                    enquiryData={enquiryData}
                    setProject={setProject}
                    setCustomer={setCustomer}
                    setValues={setValues}
                    setErrors={setErrors}
                    conversionDisabled={conversionDisabled}
                    copyStatus={copyStatus}
                  />
                )}
                {tabValue == "Details" && (
                  <>
                    {ProductTab?.tab === "ProductList" && (
                      <ProductList
                        setProductTab={setProductTab}
                        ProductTab={ProductTab}
                        values={values}
                        setValues={setValues}
                        setProductListSubmit={setProductListSubmit}
                        productListSubmit={productListSubmit}
                        SaveProductList={SaveProductList}
                        customerList={customersList}
                        inquiryList={inquiryList}
                        assignedEngineerList={assignedEngineerList}
                        projectData={projectData}
                        deliveryTermsList={deliveryTermsList}
                        paymentTermsList={paymentTermsList}
                        setTabValue={setTabValue}
                        menuRights={menuRights}
                        currencyList={currencyList}
                        currencyDetail={currencyDetail}
                        qarCurrencyDetail={companyBaseCurrency}
                        companyBaseCurrency={companyBaseCurrency}
                        editQuotation={editQuotation}
                        setQuotUserEntry={setQuotUserEntry}
                        quotUserEntry={quotUserEntry}
                        distributorList={distributorList}
                        showHeader={false}
                        isRevisionQuotation={isRevisionQuotation}
                        onSaveRevisionDraft={() =>
                          saveRevisionDraft(SaveProductList)
                        }
                        onCompleteRevision={completeQuotationRevision}
                        revisionCompleting={revisionCompleting}
                      />
                    )}
                    {ProductTab?.tab === "MainCategory" && (
                      <MainCategory
                        setProductTab={setProductTab}
                        ProductTab={ProductTab}
                      />
                    )}
                    {ProductTab?.tab === "SubCategory" && (
                      <SubCategory
                        setProductTab={setProductTab}
                        ProductTab={ProductTab}
                      />
                    )}
                    {ProductTab?.tab === "ProductSubCategory" && (
                      <ProductSubCategory
                        setProductTab={setProductTab}
                        ProductTab={ProductTab}
                      />
                    )}
                    {ProductTab?.tab === "AssemblyConfigure" && (
                      <AssemblyConfigure
                        setProductTab={setProductTab}
                        ProductTab={ProductTab}
                      />
                    )}
                    {ProductTab?.tab === "ProductQuotation" && (
                      <ProductQuotation
                        setProductTab={setProductTab}
                        ProductTab={ProductTab}
                        productConfig={productConfig}
                        setProductConfig={setProductConfig}
                        productSubmit={productSubmit}
                        setProductSubmit={setProductSubmit}
                        values={values}
                        setValues={setValues}
                        attributes={attributes}
                        setAttributes={setAttributes}
                        configSetting={configSetting}
                        setConfigSetting={setConfigSetting}
                        SaveProductMarkAdd={SaveProductMarkAdd}
                        isRevisionQuotation={isRevisionQuotation}
                        onSaveRevisionDraft={() =>
                          saveRevisionDraft(SaveProductMarkAdd)
                        }
                        onCompleteRevision={completeQuotationRevision}
                        revisionCompleting={revisionCompleting}
                        menuRights={menuRights}
                        currencyDetail={currencyDetail}
                        distributorList={distributorList}
                        companyBaseCurrency={companyBaseCurrency}
                      />
                    )}
                  </>
                )}
              </QuoteFormPanel>
            </div>
          </div>
        </section>
        {/* <!-- deleteModal--> */}
        <DeleteModal />

        {/* <!-- saveSuccessModal--> */}
        <SaveSuccessModel
          createMsg={createMsg}
          setCreateMsg={setCreateMsg}
          setShow={setShow}
          show={show}
          SuccessDoneClick={SuccessDoneClick}
        />
        <ErrorMessage
          Show={errorShow?.show}
          errorMessage={errorShow?.errorMessage}
          ErrorDoneClick={ErrorDoneClick}
        />

        {/* <!-- printModal--> */}
        <PrintModalStart />
        <SDRequest />
      </div>

      <AddNewCustomerModal
        setCustList={setCustomerList}
        disabledDistributor={true}
        showNewCust={showNewCust}
        setShowNewCust={setShowNewCust}
        customerData={customersList}
        distributorData={distributorList}
        countryData={countryList}
        assignedEngineerData={assignedEngineerList}
        pageName="jobinhand"
        setNewAddedCustomer={setNewAddedCustomer}
        distributorInq={distributor}
      />
      <AddNewProjectModal
        showNewProj={showNewProj}
        setShowNewProj={setShowNewProj}
        customerData={customerData}
        projectLists={projectsList}
        projectData={projectData}
        setProjectData={setProjectList}
        countryData={countryList}
        distributordata={distributorList}
        selectedDistributor={distributor}
        setProjectName={setNewAddedProject}
        pageName="jobinhand"
      />
    </>
  );
};

export default JobInHand;
